import { selector, selectorFamily } from "recoil";

import type { RydeUiUnit } from "../../models";
import {
  apiDataFetchingAtom,
  customLoaderAtom,
  drawersAtom,
  dropdownsIsFetchingAtom,
  isSessionGateLoaderAtom,
  loadingEditFormContentAtomFamily,
} from "../atoms";

export const isBlockingFullscreenLoaderSelector = selector<boolean>({
  key: "isBlockingFullscreenLoader",
  get: ({ get }) => {
    if (get(customLoaderAtom)) {
      return true;
    }

    if (get(drawersAtom).length > 0) {
      return false;
    }

    return get(apiDataFetchingAtom);
  },
});

export const isGlobalLoaderActiveSelector = selector<boolean>({
  key: "isGlobalLoaderActive",
  get: ({ get }) => {
    if (get(isSessionGateLoaderAtom)) {
      return true;
    }

    return get(isBlockingFullscreenLoaderSelector);
  },
});

export const loadersEditFormDataSF = selectorFamily<boolean, RydeUiUnit>({
  key: "loadersEditFormDataSF",
  get:
    entity =>
    ({ get }) => {
      if (get(isSessionGateLoaderAtom) || get(customLoaderAtom)) {
        return false;
      }

      const editFormLoading = get(loadingEditFormContentAtomFamily(entity));
      const loadingDropdowns = get(dropdownsIsFetchingAtom);
      return Boolean(editFormLoading || loadingDropdowns);
    },
});

export const loadersEditFormWithApiDataSF = selectorFamily<boolean, RydeUiUnit>(
  {
    key: "loadersEditFormWithApiDataSF",
    get:
      entity =>
      ({ get }) => {
        if (get(isSessionGateLoaderAtom)) {
          return false;
        }

        const isCustomLoaderActive = get(customLoaderAtom);
        const isGlobalLoaderActive = get(apiDataFetchingAtom);
        const editFormLoading = get(loadingEditFormContentAtomFamily(entity));
        const loadingDropdowns = get(dropdownsIsFetchingAtom);
        return Boolean(
          editFormLoading ||
          loadingDropdowns ||
          isGlobalLoaderActive ||
          isCustomLoaderActive,
        );
      },
  },
);
